import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=695f9f3d&"
import script from "./integrations.vue?vue&type=script&lang=js&"
export * from "./integrations.vue?vue&type=script&lang=js&"
import style0 from "./integrations.vue?vue&type=style&index=0&id=695f9f3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QItemLabel,QInput,QBtn,QInnerLoading,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QItemLabel,QInput,QBtn,QInnerLoading,QIcon})
